
const hasServiceFeeInvoiceSqlClause = `
  case
    when coalesce(pp.separate_service_fee_and_principal, false) = true then 0
    else pp.service_fee
  end
`

const optimizedPayablesListQuery = (excludeOrderId, includeTxnInfo) => {
  return `
    WITH iq_join AS (
      SELECT invoice_id, company_code, invoice_txn_id
      FROM avocado.data_invoice_quickbooks
      UNION ALL
      SELECT invoice_id, company_code, qbo_txn_id
      FROM avocado.data_invoicepaymentplan ip
      JOIN avocado.data_invoice_quickbooks iq
        ON iq.invoice_txn_id = ip.qbo_txn_id and ip.qbo_company_code = iq.company_code
    )
    , il_first AS (
      SELECT DISTINCT ON (invoice_id)
             invoice_id, shipment_id, order_id
      FROM avocado.data_invoice_line
      WHERE shipment_id IS NOT NULL OR order_id IS NOT NULL
      ORDER BY invoice_id
    )
    , transactions as (
    select distinct
      txn.created_at,
      txn.updated_at,
      txn.id,
      txn.company_code,
      txn.txn_id,
      txn.quickbooks_doc_number,
      txn.txn_type,
      txn.txn_date,
      txn.due_date,
      txn.quickbooks_created_at,
      txn.quickbooks_updated_at,
      txn.amount,
      txn.amount_paid,
      txn.description,
      txn.location_id,
      txn.quickbooks_account_id,
      txn.order_type,
      pp.id AS payment_plan_id,
      row_to_json(pp)::jsonb AS payment_plan,
      il.shipment_id,
      COALESCE(il.order_id, p.order_id) AS order_id
    FROM avocado.data_quickbookstransactions txn
    LEFT JOIN avocado.data_paymentplan pp
      ON txn.quickbooks_account_id = pp.quickbooks_account_id
     AND txn.company_code = pp.company_code
     AND txn.txn_type = 'loan'
     AND txn.location_id = pp.location_id
    LEFT JOIN iq_join iq
      ON iq.invoice_txn_id = txn.txn_id
     AND iq.company_code = txn.company_code
    LEFT JOIN il_first il
      ON il.invoice_id = iq.invoice_id
    LEFT JOIN avocado.data_payment p
      ON p.payment_data ->> 'reference' = txn.description
     AND p.location_id = txn.location_id
    WHERE txn.location_id = $1
    UNION ALL
              -- Get payments not stored on the avocado.data_quickbookstransactions table
              SELECT
                ip.created_at,
                ip.updated_at,
                ip.id::uuid,
                ip.company_code,
                ip.txn_id,
                null::text as quickbooks_doc_number,
                'payment' as txn_type,
                ip.txn_date,
                null as due_date,
                ip.quickbooks_created_at,
                ip.quickbooks_updated_at,
                ip.amount,
                null as amount_paid,
                null as description,
                ip.location_id,
                null as quickbooks_account_id,
                null as order_type,
                null as payment_plan_id,
                null as payment_plan,
                null as shipment_id,
                null as order_id
              FROM avocado.data_quickbooksinvoicepayment ip
              LEFT JOIN avocado.data_quickbookstransactions qt on ip.txn_id = qt.txn_id and ip.company_code = qt.company_code
              WHERE qt.id is null and ip.amount != 0 and coalesce(ip.unapplied_amount, 0) = 0
                 and ip.location_id = $1
    )
    , installments AS (

        SELECT
          coalesce(ppi.id, inst.id) as id,
          coalesce(ppi.code, inst.code) as code,
          inst.location_id,
          inst.payment_plan_id,
          inst.start_date,
          inst.due_date,
          ${includeTxnInfo ? 'inst.txn_number,' : ''}
          inst.amount,
          inst.amount_paid,
          inst.is_paid,
          inst.created_at,
          inst.updated_at,
          t.order_id,
          t.shipment_id,
          row_to_json(pp)::jsonb as payment_plan
        FROM "avocado"."data_paymentplan" pp
        LEFT join transactions t on t.payment_plan_id = pp.id
        LEFT JOIN avocado.data_location l ON pp.location_id = l.uuid
        LEFT JOIN LATERAL (
          -- The lateral join will generate a series of installment rows
          -- per payment plan row and calculate if and how much was paid on
          -- an installment using the customers loan quickbooks account balance.
          SELECT
            pp.id as id,
            'P-' || upper(l.code) || '-' || upper(substring(l.market_id from 1 for 3)) || '-' ||
            to_char(pp.start_date + (nth - 1) * calc.freq, 'YYMMDD') as code,
            pp.location_id,
            pp.id as payment_plan_id,
            pp.start_date as start_date,
            cast(pp.start_date + (nth - 1) * calc.freq as date) as due_date,
            -- The installment amount on the paymentplan includes the service fee
            pp.installment_amount as amount,
            -- The assumption is, that if any amount has been paid for the installment,
            -- then the service fee for the installment is already paid, because that
            -- is booked first.
            case when calc.installment_principal_paid > 0
              then calc.installment_principal_paid + ${hasServiceFeeInvoiceSqlClause}
              else 0 end as amount_paid,
            balance,
            calc.installment_principal_paid + ${hasServiceFeeInvoiceSqlClause} = pp.installment_amount as is_paid,
            pp.created_at,
            pp.updated_at
            ${includeTxnInfo ? ',nth as txn_number' : ''}

          FROM generate_series(1, pp.term) nth,
          -- Lateral subquery to calculate some values for the installment rows
          LATERAL (
            SELECT
              (pp.installment_amount*term) - (pp.installment_amount*nth)  as balance,
              -- Get the amount paid on the installment without service fee.
              -- We iterate over the installments and set the amount paid to
              -- the total paid minus what was already assigned to the previous
              -- installments.
              -- We don't use payment_plan.past_due(the principal) here, because
              -- payment_plan.installment_amount has been rounded up and
              -- multiplying installment_amount(excluding the service fee)
              -- with payment_plan.term would most likely not be equal to past_due.
              -- The payment plan document for the customer shows rounded installment
              -- amounts as does the UI and thats why we use the same here.
              greatest(0, least(pp.installment_amount - ${hasServiceFeeInvoiceSqlClause},
                  ( greatest( ((pp.installment_amount - ${hasServiceFeeInvoiceSqlClause}) * term ), pp.past_due ) - pp.quickbooks_account_balance)
                  - (nth - 1) * (pp.installment_amount - ${hasServiceFeeInvoiceSqlClause})
                )) as installment_principal_paid,
              case
                when frequency = 'WEEKLY' then interval '1 week'
                when frequency = 'BIWEEKLY' then interval '2 week'
                when frequency = 'FIFTEEN_DAYS' then interval '15 days'
                when frequency = 'MONTHLY' then interval '1 month'
                when frequency = 'FORTY_FIVE_DAYS' then interval '45 days'
                when frequency = 'BIMONTHLY' then interval '2 month'
                when frequency = 'TRIMONTHLY' then interval '3 month'
              end as freq
            ) as calc
        ) as inst ON true
        LEFT join avocado.data_paymentplaninstallment ppi on ppi.payment_plan_id = inst.id and ppi.due_date = inst.due_date
         where  "pp"."is_active" IS TRUE  and inst.location_id = $1

        ),
    pending AS (

      SELECT
        p.id,
         p.data ->> 'locationId' as "location_id",
        due_date,
        p.amount,
        amount_paid,
        null AS description,
        'pending invoice payment' AS txn_type,
        quickbooks_doc_number,
        p.updated_at AS txn_date,
        p.created_at,
        p.updated_at,
        t.order_type,
        null::jsonb AS payment_plan,
        null AS shipment_id,
        null AS order_id
      FROM avocado.data_paymentdebit p
      INNER join avocado.data_quickbookstransactions t
        ON t.txn_type = 'payment'
       AND t.description ilike  '%' || ("data" -> 'remitaResponse' -> 'body' ->> 'transactionRef') || '%'
       AND t.location_id = p.data->>'locationId'
      WHERE p.data->'remitaResponse'->'body'->>'status' = 'Successful' AND t.id is null

      UNION

      SELECT
        p.id,
        p.location_id,
        due_date,
        -- The amount from paystack is in the currencies subunit, convert to main unit
        case when p.total_amount > 0 then p.total_amount
        else p.amount_in_cents / 100  end as amount,
        amount_paid,
        null AS description,
        'pending invoice payment' AS txn_type,
        quickbooks_doc_number,
        p.updated_at AS txn_date,
        p.created_at,
        p.updated_at,
        t.order_type,
        null::jsonb AS payment_plan,
        null AS shipment_id,
        null AS order_id
      FROM avocado.data_payment p
      LEFT JOIN  "avocado"."data_quickbookstransactions" t
        ON t.txn_type = 'payment'
       AND t.description = "p"."payment_data" ->> 'reference'
       AND t.location_id = p.location_id
      WHERE (p.status = 'success' OR p.status = 'client_side_paid')
      and p.payment_method != 'credit' -- we need exclude credits from pending payments list
      and t.id IS NULL
      -- Payments made prior to the specified date should not be included in the pending payment logic.
      and p.created_at > '2023-06-08'

      UNION

      SELECT
        p.id,
        location_id,
        i.due_date,
        p.amount,
        amount_paid,
        null AS description,
        'pending installment payment' AS txn_type,
        code AS quickbooks_doc_number,
        p.updated_at AS txn_date,
        p.created_at,
        p.updated_at,
        null as order_type,
        i.payment_plan,
        null AS shipment_id,
        null AS order_id
      FROM avocado.data_paymentdebit p
      INNER JOIN installments i
        ON i.code = p.reference
       AND i.location_id = p.data->>'locationId'
       AND i.amount_paid < i.amount
      WHERE p.data->'remitaResponse'->'body'->>'status' = 'Successful'
      OR p.data -> 'paystackResponse' ->> 'status' = 'success'

      UNION

      SELECT
        p.id,
        p.location_id,
        due_date,
        -- The amount from paystack is in the currencies subunit, convert to main unit
        p.amount_in_cents / 100 as amount,
        amount_paid,
        null AS description,
        'pending invoice payment' AS txn_type,
        quickbooks_doc_number,
        p.updated_at AS txn_date,
        p.created_at,
        p.updated_at,
        t.order_type,
        null::jsonb AS payment_plan,
        null AS shipment_id,
        null AS order_id
      FROM avocado.data_paygcreditpayment p
      INNER join avocado.data_quickbookstransactions t
         ON t.txn_id = p.qbo_txn_id
        AND t.company_code = p.qbo_company_code
        AND t.amount_paid < t.amount

    )
    , transactions_list AS (
          SELECT tl.* FROM (

      SELECT "t"."id",
             "t"."location_id",
             due_date,
             amount,
             amount_paid,
             description,
             txn_type,
             quickbooks_doc_number,
             txn_date,
             quickbooks_created_at as created_at,
             quickbooks_updated_at as updated_at,
             order_type,
             payment_plan,
             shipment_id,
             order_id
             ${includeTxnInfo ? `,txn_id, null as txn_number` : ``}
      FROM transactions "t"

        WHERE "txn_type" = 'invoice' AND ( coalesce("amount", 0) - coalesce("amount_paid", 0) ) > 0

            UNION
            SELECT * FROM (
      SELECT
        id,
        location_id,
        due_date,
        amount,
        amount_paid,
        null as description,
        'installment' as txn_type,
        code as quickbooks_doc_number,
        least(now()::date, due_date) as txn_date,
        created_at,
        updated_at,
        null as order_type,
        payment_plan,
        shipment_id,
        order_id
        ${includeTxnInfo ? ` ,null as txn_id, txn_number` : ``}
      FROM installments
     WHERE ("amount" - coalesce("amount_paid", 0) > 0)) il
          ) tl
          LEFT OUTER JOIN pending p
            ON p.location_id = tl.location_id
           AND p.quickbooks_doc_number = tl.quickbooks_doc_number
          WHERE p.id IS NULL
        ),
        location_transactions AS (
          SELECT * FROM transactions_list
            WHERE "location_id" = $1
              ${excludeOrderId ? ` AND (coalesce(order_id, '') = '' or order_id != $2) ` : ''}
        ),
        overdue_transactions AS (
          SELECT
            'overdue' AS week,
            coalesce (jsonb_agg(t order by t.due_date asc, t.created_at asc, t.txn_type asc), '[]'::jsonb) AS transactions,
            coalesce (sum(amount - coalesce(amount_paid, 0)), 0) AS totalDue
          FROM location_transactions t WHERE due_date < current_date and (amount - amount_paid) <> 0
        ),
        weekly_transactions AS (
          SELECT
            CASE
              WHEN (extract (day from date_trunc('week', due_date) - date_trunc('week', CURRENT_TIMESTAMP))::integer / 7) < 0 THEN '0'
              ELSE (extract (day from date_trunc('week', due_date) - date_trunc('week', CURRENT_TIMESTAMP))::integer / 7)::text
            END AS week,
            jsonb_agg(t order by t.due_date asc, t.created_at asc, t.txn_type asc) AS transactions,
            sum(amount - coalesce(amount_paid, 0)) AS totalDue
          FROM location_transactions t WHERE due_date >= current_date and (amount - amount_paid) <> 0
          group by week order by week
        )

        SELECT * FROM overdue_transactions
        UNION ALL
        SELECT * FROM weekly_transactions
  `
}

const optimizedTransactionListQuery = ({
  limit = 50,
  offset = 0,
  locationId,
  txnType,
  noLimit,
  overduePayment = false,
  startDate,
  endDate
}) => {
  const props = [locationId]
  let whereCondition = 'WHERE location_id = $1'
  const orderCondition = 'ORDER BY txn_date DESC, txn_type ASC'
  let propsIncrement = 1
  if (txnType) {
    propsIncrement++
    whereCondition = `${whereCondition} AND tl.txn_type = $${propsIncrement} `
    props.push(txnType)
  }

  if (overduePayment) {
    whereCondition = `${whereCondition} AND tl.amount_paid < tl.amount AND now() >= tl.due_date`
  }

  if (startDate && endDate) {
    propsIncrement++
    whereCondition = `${whereCondition} AND txn_date >= $${propsIncrement} `
    propsIncrement++
    whereCondition = `${whereCondition} AND txn_date < $${propsIncrement} `
    props.push(...[startDate, endDate])
  }

  if (!noLimit) {
    props.push(limit, offset)
  }
  const limitCondition = `LIMIT $${props.length - 1} OFFSET $${props.length}`

  return {
    query: `
      WITH all_txn AS (
        SELECT
          txn.created_at,
          txn.updated_at,
          txn.id,
          txn.company_code,
          txn.txn_id,
          txn.quickbooks_doc_number,
          txn.txn_type,
          txn.txn_date,
          txn.due_date,
          txn.quickbooks_created_at,
          txn.quickbooks_updated_at,
          txn.amount,
          txn.amount_paid,
          txn.description,
          txn.location_id,
          txn.quickbooks_account_id,
          txn.order_type,
          pp.id AS payment_plan_id,
          row_to_json(pp)::jsonb AS payment_plan,
          iq.invoice_id,
          iq.source
        FROM avocado.data_quickbookstransactions txn
        LEFT JOIN avocado.data_paymentplan pp
          ON txn.quickbooks_account_id = pp.quickbooks_account_id
         AND txn.company_code = pp.company_code
         AND txn.txn_type = 'loan'
         AND txn.location_id = pp.location_id

        LEFT JOIN avocado.data_invoicepaymentplan ip
          ON ip.paymentplan_id = pp.id

        -- Split the OR join into three UNION branches
        LEFT JOIN LATERAL (
            SELECT invoice_id, 'invoice_txn_id' AS source
            FROM avocado.data_invoice_quickbooks iq
            WHERE iq.invoice_txn_id = txn.txn_id
              AND iq.company_code = txn.company_code

            UNION ALL

            SELECT invoice_id, 'ip_qbo_txn_id'
            FROM avocado.data_invoice_quickbooks iq
            WHERE iq.invoice_txn_id = ip.qbo_txn_id
              AND iq.company_code = ip.qbo_company_code

            UNION ALL

            SELECT invoice_id, 'creditmemo_txn_id'
            FROM avocado.data_invoice_quickbooks iq
            WHERE iq.creditmemo_txn_id = txn.txn_id
              AND iq.company_code = txn.company_code
        ) iq ON TRUE
        WHERE txn.location_id = $1
      ),
      invoice_info AS (
        SELECT DISTINCT ON (invoice_id)
          invoice_id,
          shipment_id,
          order_id
        FROM avocado.data_invoice_line
        WHERE shipment_id IS NOT NULL OR order_id IS NOT NULL
        ORDER BY invoice_id
      ) ,

      transactions AS (
        SELECT
            t.created_at,
            t.updated_at,
            t.id,
            t.company_code,
            t.txn_id,
            t.quickbooks_doc_number,
            t.txn_type,
            t.txn_date,
            t.due_date,
            t.quickbooks_created_at,
            t.quickbooks_updated_at,
            t.amount,
            t.amount_paid,
            t.description,
            t.location_id,
            t.quickbooks_account_id,
            t.order_type,
            t.payment_plan_id,
            t.payment_plan,
            il.shipment_id,
            COALESCE(il.order_id, p.order_id) AS order_id
        FROM all_txn t
        LEFT JOIN invoice_info il ON il.invoice_id = t.invoice_id
        LEFT JOIN avocado.data_payment p
          ON p.payment_data ->> 'reference' = t.description
         AND p.location_id = t.location_id

         UNION ALL
          -- Get payments not stored on the avocado.data_quickbookstransactions table
          SELECT
            ip.created_at,
            ip.updated_at,
            ip.id::uuid,
            ip.company_code,
            ip.txn_id,
            null::text as quickbooks_doc_number,
            'payment' as txn_type,
            ip.txn_date,
            null as due_date,
            ip.quickbooks_created_at,
            ip.quickbooks_updated_at,
            ip.amount,
            null as amount_paid,
            null as description,
            ip.location_id,
            null as quickbooks_account_id,
            null as order_type,
            null as payment_plan_id,
            null as payment_plan,
            null as shipment_id,
            null as order_id
          FROM avocado.data_quickbooksinvoicepayment ip
          LEFT JOIN avocado.data_quickbookstransactions qt on ip.txn_id = qt.txn_id and ip.company_code = qt.company_code
          WHERE qt.id is null and ip.amount != 0 and coalesce(ip.unapplied_amount, 0) = 0
           and ip.location_id = $1
      )
      ,
      installments AS (
          SELECT
            coalesce(ppi.id, inst.id) as id,
            coalesce(ppi.code, inst.code) as code,
            inst.location_id,
            inst.payment_plan_id,
            inst.start_date,
            inst.due_date,
            inst.amount,
            inst.amount_paid,
            inst.is_paid,
            inst.created_at,
            inst.updated_at,
            null as order_id,
            null as shipment_id,
            row_to_json(pp)::jsonb as payment_plan
          FROM "avocado"."data_paymentplan" pp

          LEFT JOIN avocado.data_location l ON pp.location_id = l.uuid
          LEFT JOIN LATERAL (
            -- The lateral join will generate a series of installment rows
            -- per payment plan row and calculate if and how much was paid on
            -- an installment using the customers loan quickbooks account balance.
            SELECT
              pp.id as id,
              'P-' || upper(l.code) || '-' || upper(substring(l.market_id from 1 for 3)) || '-' ||
              to_char(pp.start_date + (nth - 1) * calc.freq, 'YYMMDD') as code,
              pp.location_id,
              pp.id as payment_plan_id,
              pp.start_date as start_date,
              cast(pp.start_date + (nth - 1) * calc.freq as date) as due_date,
              -- The installment amount on the paymentplan includes the service fee
              pp.installment_amount as amount,
              -- The assumption is, that if any amount has been paid for the installment,
              -- then the service fee for the installment is already paid, because that
              -- is booked first.
              case when calc.installment_principal_paid > 0
                then calc.installment_principal_paid + ${hasServiceFeeInvoiceSqlClause}
                else 0 end as amount_paid,
              balance,
              calc.installment_principal_paid + ${hasServiceFeeInvoiceSqlClause} = pp.installment_amount as is_paid,
              pp.created_at,
              pp.updated_at

            FROM generate_series(1, pp.term) nth,
            -- Lateral subquery to calculate some values for the installment rows
            LATERAL (
              SELECT
                (pp.installment_amount*term) - (pp.installment_amount*nth)  as balance,
                -- Get the amount paid on the installment without service fee.
                -- We iterate over the installments and set the amount paid to
                -- the total paid minus what was already assigned to the previous
                -- installments.
                -- We don't use payment_plan.past_due(the principal) here, because
                -- payment_plan.installment_amount has been rounded up and
                -- multiplying installment_amount(excluding the service fee)
                -- with payment_plan.term would most likely not be equal to past_due.
                -- The payment plan document for the customer shows rounded installment
                -- amounts as does the UI and thats why we use the same here.
                greatest(0, least(pp.installment_amount - ${hasServiceFeeInvoiceSqlClause},
                    ( greatest( ((pp.installment_amount - ${hasServiceFeeInvoiceSqlClause}) * term ), pp.past_due ) - pp.quickbooks_account_balance)
                    - (nth - 1) * (pp.installment_amount - ${hasServiceFeeInvoiceSqlClause})
                  )) as installment_principal_paid,
                case
                  when frequency = 'WEEKLY' then interval '1 week'
                  when frequency = 'BIWEEKLY' then interval '2 week'
                  when frequency = 'FIFTEEN_DAYS' then interval '15 days'
                  when frequency = 'MONTHLY' then interval '1 month'
                  when frequency = 'FORTY_FIVE_DAYS' then interval '45 days'
                  when frequency = 'BIMONTHLY' then interval '2 month'
                  when frequency = 'TRIMONTHLY' then interval '3 month'
                end as freq
              ) as calc
          ) as inst ON true
          LEFT join avocado.data_paymentplaninstallment ppi on ppi.payment_plan_id = inst.id and ppi.due_date = inst.due_date
           where  "pp"."is_active" IS TRUE  and inst.location_id = $1
      )
      ,
      txn_types as (
        SELECT * FROM (VALUES
          ('payment', 'credit'),
          ('installment payment', 'credit'),
          ('pending invoice payment', 'pending-credit'),
          ('pending installment payment', 'pending-credit'),
          ('credit memo', 'credit'),
          ('loan', 'credit'),
          ('write-off', 'credit'),
          ('bonus', 'credit'),
          ('invoice', 'debit'),
          ('installment', 'debit'),
          ('refund', 'debit')
        ) tt(txn_type, posting_type)
      )
      ,
      pending AS (

        SELECT
          p.id,
           p.data ->> 'locationId' as "location_id",
          due_date,
          p.amount,
          amount_paid,
          null AS description,
          'pending invoice payment' AS txn_type,
          quickbooks_doc_number,
          p.updated_at AS txn_date,
          p.created_at,
          p.updated_at,
          t.order_type,
          null::jsonb AS payment_plan,
          null AS shipment_id,
          null AS order_id
        FROM avocado.data_paymentdebit p
        INNER join avocado.data_quickbookstransactions t
          ON t.txn_type = 'payment'
         AND t.description ilike  '%' || ("data" -> 'remitaResponse' -> 'body' ->> 'transactionRef') || '%'
         AND t.location_id = p.data->>'locationId'
        WHERE p.data->'remitaResponse'->'body'->>'status' = 'Successful' AND t.id is null

        UNION

        SELECT
          p.id,
          p.location_id,
          due_date,
          -- The amount from paystack is in the currencies subunit, convert to main unit
          case when p.total_amount > 0 then p.total_amount
          else p.amount_in_cents / 100  end as amount,
          amount_paid,
          null AS description,
          'pending invoice payment' AS txn_type,
          quickbooks_doc_number,
          p.updated_at AS txn_date,
          p.created_at,
          p.updated_at,
          t.order_type,
          null::jsonb AS payment_plan,
          null AS shipment_id,
          null AS order_id
        FROM avocado.data_payment p
        LEFT JOIN  "avocado"."data_quickbookstransactions" t
          ON t.txn_type = 'payment'
         AND t.description = "p"."payment_data" ->> 'reference'
         AND t.location_id = p.location_id
        WHERE (p.status = 'success' OR p.status = 'client_side_paid')
        and p.payment_method != 'credit' -- we need exclude credits from pending payments list
        and t.id IS NULL
        -- Payments made prior to the specified date should not be included in the pending payment logic.
        and p.created_at > '2023-06-08'

        UNION

        SELECT
          p.id,
          location_id,
          i.due_date,
          p.amount,
          amount_paid,
          null AS description,
          'pending installment payment' AS txn_type,
          code AS quickbooks_doc_number,
          p.updated_at AS txn_date,
          p.created_at,
          p.updated_at,
          null as order_type,
          i.payment_plan,
          null AS shipment_id,
          null AS order_id
        FROM avocado.data_paymentdebit p
        INNER JOIN installments i
          ON i.code = p.reference
         AND i.location_id = p.data->>'locationId'
         AND i.amount_paid < i.amount
        WHERE p.data->'remitaResponse'->'body'->>'status' = 'Successful'
        OR p.data -> 'paystackResponse' ->> 'status' = 'success'

        UNION

        SELECT
          p.id,
          p.location_id,
          due_date,
          -- The amount from paystack is in the currencies subunit, convert to main unit
          p.amount_in_cents / 100 as amount,
          amount_paid,
          null AS description,
          'pending invoice payment' AS txn_type,
          quickbooks_doc_number,
          p.updated_at AS txn_date,
          p.created_at,
          p.updated_at,
          t.order_type,
          null::jsonb AS payment_plan,
          null AS shipment_id,
          null AS order_id
        FROM avocado.data_paygcreditpayment p
        INNER join avocado.data_quickbookstransactions t
           ON t.txn_id = p.qbo_txn_id
          AND t.company_code = p.qbo_company_code
          AND t.amount_paid < t.amount

      )
      , transactions_list AS (

        SELECT "t"."id",
               "t"."location_id",
               due_date,
               amount,
               amount_paid,
               description,
               txn_type,
               quickbooks_doc_number,
               txn_date,
               quickbooks_created_at as created_at,
               quickbooks_updated_at as updated_at,
               order_type,
               payment_plan,
               shipment_id,
               order_id
        FROM transactions "t"

              UNION
              SELECT * FROM (
        SELECT
          id,
          location_id,
          due_date,
          amount,
          amount_paid,
          null as description,
          'installment' as txn_type,
          code as quickbooks_doc_number,
          least(now()::date, due_date) as txn_date,
          created_at,
          updated_at,
          null as order_type,
          payment_plan,
          shipment_id,
          order_id
        FROM installments
       WHERE due_date <= (current_date + interval '6 days') or is_paid = true) i
              UNION
              SELECT * FROM (SELECT * FROM pending ) p
            )
          SELECT tl.*, posting_type FROM transactions_list tl
          LEFT JOIN txn_types tt ON tl.txn_type = tt.txn_type
         ${whereCondition} ${orderCondition} ${!noLimit ? limitCondition : ''}
    `,
    props
  }
}

module.exports = {
  optimizedPayablesListQuery,
  optimizedTransactionListQuery
}
